import React, {useState, useEffect, useContext} from "react";
import {useHistory} from 'react-router-dom';
import {DEFAULT_BLUE} from "../constants/general-constants";
import {functions} from "../constants/common-functions";
import {JWT} from "../constants/local-storage";
import {store} from '../context/store';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../constants/general-constants";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../constants/general-constants";
import {CSSTransition} from 'react-transition-group';
import bluepin from '../../images/bluepin.png';
import darkbluepin from '../../images/darkbluepin.png';
import orangepin from '../../images/orangepin.png';
import redpin from '../../images/redpin.png';
import purplepin from '../../images/purplepin.png';
import blackpin from '../../images/blackpin.png';
import './maplist.css';
import MapListLocation from '../components/MapListLocation';

export default function MapList({id, listDisplay, setListDisplay}){
	
	const [locations, setLocations] = useState([]);
	
	useEffect(() => {
		functions.getObjectFromAjax("/resolutionsoftwareplatform/facilities", null, populateLocations);
	}, []);
	
	const mapPins = [
		{label:'Branch', icon:bluepin},
		{label:'Office', icon:darkbluepin},
		{label:'Warehouse', icon:orangepin},
		{label:'Store', icon:redpin},
		{label:'Campus', icon:purplepin},
		{label:'Manufacturing', icon:blackpin}
	];
	
	const getMapPin = () => {
		return mapPins[(Math.round(Math.random() * (mapPins.length - 1)))];
	};
	
	const populateLocations = (results) => {
		let tempLocations = [];
		for(let i=0; i<results.length; i++){
			let mapPin = getMapPin();
			tempLocations.push({
				id:results[i].id,
				code:results[i].code,
				name:results[i].name,
				description:results[i].description,
				icon:mapPin.icon,
				type:mapPin.label,
				photoFile:results[i].photoFile
			});
		}
		setLocations(tempLocations);
	}
	
	const closeList = () => {
 		setListDisplay(false);
 	};
 	
 	const thisContainer = {
 		display:"flex",
 		width:"100%",
 		height:"100%",
 		flexDirection:"column",
 		overflow:"auto"
 	};
 	
 	const locationDisplay = locations.map((item, index) => 
 		<MapListLocation
 			location={item}
 		/>
 	);
	
	return (
		<CSSTransition
				    in={listDisplay}
				    classNames="maplist"
				    timeout={1000}
				    appear={false}
			>
			<div className="maplist">
				<div style={thisContainer}>
					{locationDisplay}
				</div>
			</div>
		</CSSTransition>
	);
}